<article class="featured-card">
  <a [routerLink]="['/blog', post().slug]" class="featured-card__image-link" tabindex="-1" aria-hidden="true">
    <div class="featured-card__image-wrapper">
      <img
        [src]="post().imageUrl"
        [alt]="post().imageAlt || post().title"
        [width]="post().imageWidth"
        [height]="post().imageHeight"
        class="featured-card__image"
      />
    </div>
  </a>

  <div class="featured-card__content">
    <div class="featured-card__badges">
      <app-badge variant="highlight">{{ copy.featuredBadge }}</app-badge>
      <span
        class="featured-card__game-badge"
        [style.background-color]="post().game.accentColor"
      >{{ post().game.name }}</span>
    </div>

    <div class="featured-card__meta">
      <time class="featured-card__date" [attr.datetime]="post().publishedAt">{{ post().publishedAt | blogDate }}</time>
      <span class="featured-card__separator">&middot;</span>
      <span class="featured-card__read-time">{{ post().readTimeMinutes | blogReadTime }}</span>
    </div>

    <h2 class="featured-card__title">
      <a [routerLink]="['/blog', post().slug]" class="featured-card__title-link">{{ post().title }}</a>
    </h2>

    <p class="featured-card__excerpt">{{ post().excerpt }}</p>

    <div class="featured-card__categories">
      @for (cat of post().categories; track cat.id) {
        <a
          class="featured-card__category-pill"
          [routerLink]="['/blog']"
          [queryParams]="{ category: cat.slug }"
        >{{ cat.name }}</a>
      }
    </div>

    <!-- B125: la tarjeta pública no trae autor (P41); solo si llega. -->
    @if (post().authorName) {
      <div class="featured-card__author">
        <img
          class="featured-card__avatar"
          [src]="post().authorAvatarUrl"
          [alt]="post().authorName"
          width="40"
          height="40"
          loading="lazy"
        />
        <div class="featured-card__author-info">
          <span class="featured-card__author-name">{{ post().authorName }}</span>
          <span class="featured-card__author-role">{{ post().authorRole }}</span>
        </div>
      </div>
    }
  </div>
</article>
